export default function generatePagination(totalPages: number, activePage: number) {
    const maxPagesToShow = 5; // Количество страниц, отображаемых в начале или в конце
    const pages = [...Array(totalPages).keys()].map((num) => num + 1);

    let pagesToShow = pages.reduce<Array<{ ellipsis: boolean; targetPage: number }>>((finalArr, page) => {
        // Показать первые 5 страниц, если активная страница — одна из первых четырех
        if (page <= maxPagesToShow && activePage <= 4) {
            finalArr.push({ ellipsis: false, targetPage: page });
        }
        // Показать последние 5 страниц, если активная страница — одна из последних четырех
        else if (activePage >= totalPages - 3 && page >= totalPages - maxPagesToShow + 1) {
            finalArr.push({ ellipsis: false, targetPage: page });
        }
        // Показать первую страницу, последнюю страницу и две страницы до и после активной, если активная страница находится в середине
        else if (page === 1 || page === totalPages || (page >= activePage - 2 && page <= activePage + 2)) {
            finalArr.push({ ellipsis: false, targetPage: page });
        }
        return finalArr;
    }, []);

    // Добавление маркеров пропущенных страниц ("...")
    pagesToShow = pagesToShow.reduce<Array<{ ellipsis: boolean; targetPage: number }>>((finalArr, page, idx, arr) => {
        if (idx !== 0 && page.targetPage - arr[idx - 1].targetPage > 1) {
            let targetPage = (page.targetPage + arr[idx - 1].targetPage) / 2;
            finalArr.push({ ellipsis: true, targetPage: Math.round(targetPage) });
        }

        finalArr.push({ ellipsis: false, targetPage: page.targetPage });
        return finalArr;
    }, []);

    return pagesToShow;
}
